import palette from '../theme/palette';

const styleOverrides = {
  root: {
    '@supports ((-webkit-backdrop-filter: blur(2px)) or (backdrop-filter: blur(2px)))': {
      backdropFilter: 'blur(2px)',
    },
    backgroundColor: palette.backdrop,
  },
  invisible: {
    '@supports ((-webkit-backdrop-filter: blur(2px)) or (backdrop-filter: blur(2px)))': {
      backdropFilter: 'none',
    },
    backgroundColor: 'transparent',
  },
};

export default styleOverrides;
